module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ko-KR.98973446.jpg";